import { render } from "./searchbox.vue?vue&type=template&id=3b7ea541"
import script from "./searchbox.vue?vue&type=script&lang=js"
export * from "./searchbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__